/* @flow */
import React from 'react';

import Text from 'components/Text.jsx';
import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import HeartShare from 'components/HeartShare.jsx';
import LayerTrigger from 'components/LayerTrigger.jsx';
import Link from 'components/Link.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import UserNavigationMenu from 'components/UserNavigationMenu.jsx';
import RecentView from 'chat/components/RecentView.jsx';
import SupportDialog from 'support/components/SupportDialog.jsx';
import ZopimLink from 'support/components/ZopimLink.jsx';
import ZopimChevronBox from 'support/components/ZopimChevronBox.jsx';
import AdminConsoleAccess from 'admin/components/AdminConsoleAccess.jsx';

import styles from './styles/AppTopBar.css';

type Props = {
  showRCE?: boolean,
  showZopim?: boolean,
  userName: string,
  displayIcon?: boolean,
  showingRecent?: boolean,
  showRecent: Function,
  hideRecent: Function,
};

class AppTopBar extends React.Component {
  props: Props;

  componentDidUpdate() {
    if (this.props.showingRecent) {
      this.showRecentView();
    } else {
      this.hideRecentView();
    }
  }

  hideRecentView = () => {
    this.props.hideRecent();
    if (this.refs.recentView) {
      this.refs.recentView.hideLayer();
    }
  };

  showRecentView = () => {
    this.props.showRecent();
    if (this.refs.recentView) {
      this.refs.recentView.showLayer();
    }
  };

  renderIcon() {
    return (
      <div className={styles.icon} >
        <LayerTrigger
          data-test-selector="recent-view-trigger"
          ref="recentView"
          layer={<RecentView hide={this.hideRecentView} />}
          trigger="manual">
          {
            this.props.showingRecent ?
              <div /> :
              (
              <Link data-test-selector="recent-view-unread-icon" onClick={this.showRecentView}>
                <Glyph name="clock" className={styles.glyph} solo />
              </Link>
              )
          }
        </LayerTrigger>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.this}>
        <div className={styles.left}>
          <UserNavigationMenu showSettings showGetTheApp showLogout showRCE={this.props.showRCE}>
            <Link color="inherit" className={styles.userLink}>
              <Text truncate size="medium">{this.props.userName}</Text>
              <Glyph name="chevron-down" size="xxsmall" />
            </Link>
          </UserNavigationMenu>
          {this.props.displayIcon && this.renderIcon()}
        </div>
        <div className={styles.actions}>
          <AdminConsoleAccess>
            <Link
              eventElementName="go_to_admin_console"
              className={styles.adminConsoleLink}
              to="/admin"
              color="inherit"
              target="_blank">
              <Button size="xxsmall" level="secondary" color="pitch">
                Go to Admin Console
              </Button>
            </Link>
          </AdminConsoleAccess>
          {this.props.showZopim &&
            <ZopimLink>
              <ZopimChevronBox />
            </ZopimLink>
          }
          <ModalTrigger data-test-selector="support-dialog-trigger" modal={<SupportDialog />}>
            <Link eventElementName="Navigation-help" color="pitch">
              <Glyph className={styles.help} name="help" size="large" solo />
            </Link>
          </ModalTrigger>
          <HeartShare className={styles.share} color="pitch" size="large" />
        </div>
      </div>
    );
  }
}


export default AppTopBar;



// WEBPACK FOOTER //
// ./src/app/components/AppTopBar.jsx